"use client";
import Link from "next/link";
import Image from "next/image";
import React from "react";
import { usePathname } from "next/navigation";
import Hero2_Invention_Layout1 from "./Hero2-Layouts/Invention/Layout1";
import Hero2_Knowledge_Layout1 from "./Hero2-Layouts/Knowledge/Layout1";
import Hero2Potent_Herbs_Layout1 from "./Hero2-Layouts/Potentherbs/Layout1";
import Hero2_Community_Layout1 from "./Hero2-Layouts/Community/Layout1";
import Hero2_Proprietary_Layout1 from "./Hero2-Layouts/Proprietary/Layout1";
import Hero2_Invention_Layout2 from "./Hero2-Layouts/Invention/Layout2";
import Hero2_Heritage_Layout1 from "./Hero2-Layouts/Heritage/Layout1";
import Hero2_PotentHerbs_Layout1 from "./Hero2-Layouts/Potentherbs/Layout1";
import Hero2_VipinGoyal_Layout1 from "./Hero2-Layouts/Vipin-Goyal/Layout1";
import path from "path";
import Hero2_Home_Layout2 from "./Hero2-Layouts/Home/Hero2-Home-Layout-2";
import Hero2_Privacy_Layout1 from "./Hero2-Layouts/privacy-policy/Layout1";
import Hero2_Layout1 from "./Hero2-Layouts/Layout1";
import Hero2_Layout2 from "./Hero2-Layouts/Layout2";

interface Button {
  id: string;
  url: string;
  text: string;
  type: string;
  newTab: boolean;
}

interface Picture {
  data: {
    id: string;
    attributes: {
      url: string;
      name: string;
      alternativeText: string;
    };
  };
}

interface bgImage {
  data: {
    id: string;
    attributes: {
      url: string;
      name: string;
      alternativeText: string;
    };
  };
}

interface Hero2Props {
  data: {
    id: string;
    title: string;
    description: string;
    picture: Picture;
    bgImage?: bgImage;
    button: Button[];
    isLive: boolean;
  };
}

const StarIcon = React.memo(({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={className}
  >
    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
  </svg>
));

StarIcon.displayName = 'StarIcon';



const Hero2 = ({ data }: Hero2Props) => {
  if (!data?.isLive) return null;



  const pathname = usePathname();



  // **********************************************************

  // Using Proprietary layout in other pages as well 

  // **********************************************************

  return (

    <>
      {
        <Hero2_Layout2 data={data} />
      }
    </>

  );
};

export default Hero2;